import { action } from 'typesafe-actions'

import { MachineError } from './machine-error'

export enum machineErrorsActionType {
  FETCH_MACHINE_ERRORS = 'FETCH_MACHINE_ERRORS',
  FETCH_MACHINE_ERRORS_SUCCEEDED = 'FETCH_MACHINE_ERRORS_SUCCEEDED',
  THROW_ERROR = 'THROW_ERROR',
  SET_CURRENT_PAGE = 'SET_CURRENT_PAGE',
}

export const machineErrorsActions = {
  fetchMachineErrors: (limit?: number, offset?: number) =>
    action(machineErrorsActionType.FETCH_MACHINE_ERRORS, { limit, offset }),
  fetchMachineErrorsSucceeded: (machineErrors: MachineError[], totalCount: number) =>
    action(machineErrorsActionType.FETCH_MACHINE_ERRORS_SUCCEEDED, {
      machineErrors,
      totalCount,
    }),
  throwError: (error: Error) =>
    action(machineErrorsActionType.THROW_ERROR, { error }),
  setCurrentPage: (page: number) =>
    action(machineErrorsActionType.SET_CURRENT_PAGE, { page }),
}
